import { render, staticRenderFns } from "./WorkplaceView.vue?vue&type=template&id=a3a09a8e&"
import script from "./WorkplaceView.vue?vue&type=script&lang=js&"
export * from "./WorkplaceView.vue?vue&type=script&lang=js&"
import style0 from "./WorkplaceView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports